import { Easing } from '@mote/helpers/animation'
import { visualizeAudio } from '@mote/helpers/media'
import React from 'react'
import { animated, config, useSpring } from 'react-spring'
import styled from 'styled-components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'

const limitAmplitude = (amplitude, amplitudeMax = 1.7) => {
  const newAmplitude = 1 + amplitude * 3

  if (newAmplitude > amplitudeMax) {
    return amplitudeMax
  }
  return newAmplitude
}

export const MoteCardAudioVisualization = () => {
  const { audioData, playing, position, theme } = useMotePlayer()
  const [{ scale }, set] = useSpring(() => ({
    scale: 1,
    config: {
      ...config.gentle,
      easing: Easing.bezier(0.445, 0.05, 0.55, 0.95)
    }
  }))

  if (!audioData) {
    return null
  }

  const allVisualizationValues = visualizeAudio({
    position,
    audioData,
    numberOfSamples: 128
  })

  const sum = allVisualizationValues.reduce((sum, value) => sum + value, 0)
  const average = sum / allVisualizationValues.length

  set({ scale: limitAmplitude(Math.pow(256 * average, 2), 1.5) })

  return (
    <Root mixBlendMode={theme?.waveForm.mixBlendMode}>
      <PulsingDot
        playing={playing}
        style={{
          background: theme?.waveForm.background,
          transform: `scale(${playing ? scale?.getValue() : 1})`
        }}
      />
    </Root>
  )
}

const Root = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  height: 100%;
  width: 100%;
  mix-blend-mode: ${({ mixBlendMode }) => mixBlendMode};
  transform: translate(-50%, -50%);
`

const PulsingDot = animated(styled.div`
  height: 100%;
  width: 100%;
  border-radius: 100%;
  transition: transform ${({ playing }) => (playing ? 0 : 150)}ms
    cubic-bezier(0.445, 0.05, 0.55, 0.95);
  will-change: transform;
`)
